import Route from '@ember/routing/route';

export default class LinkExpiredRoute extends Route {}
